// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vrb49","col":"styles_col__1LCQH"};